import { RootState } from './index';

export const selectActiveStep = (state: RootState) => state.stake.activeStep;
export const getWalletAddress = (state: RootState) => state.stake.walletAddress;
export const getAmount = (state: RootState) => state.stake.amount;
